import { render, staticRenderFns } from "./DuplicateInvoiceButton.vue?vue&type=template&id=10ea037a&scoped=true&"
import script from "./DuplicateInvoiceButton.vue?vue&type=script&lang=ts&"
export * from "./DuplicateInvoiceButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ea037a",
  null
  
)

export default component.exports